var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "2271.943 115.366 41.662 46.145",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.867968, 0, 0, 0.854537, 2271.942695, 115.366237)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.992,0h-9.983C13.181,0,6,7.178,6,16v15c0,0.552,0.448,1,1,1h3v10c0,6.617,5.379,12,11.99,12h10.02 C38.621,54,44,48.617,44,42V32h3c0.552,0,1-0.448,1-1V16C48,7.178,40.819,0,31.992,0z M22.008,2h9.983 c6.333,0,11.691,4.225,13.418,10H8.59C10.317,6.225,15.675,2,22.008,2z M45.84,14c0.048,0.33,0.085,0.663,0.109,1H8.051 c0.024-0.337,0.062-0.67,0.109-1H45.84z M42,42c0,5.514-4.481,10-9.99,10H21.99C16.481,52,12,47.514,12,42V32h0.057l0.651,11.073 C12.901,46.341,15.722,49,18.998,49H24c0.552,0,1-0.448,1-1v-3h5v3c0,0.552,0.448,1,1,1h4.002c3.275,0,6.097-2.659,6.289-5.927 L41.943,32H42V42z M28,34v-2h11.939l-0.644,10.956C39.164,45.186,37.238,47,35.002,47H32v-3c0-0.552-0.448-1-1-1h-7 c-0.552,0-1,0.448-1,1v3h-4.002c-2.236,0-4.162-1.814-4.293-4.044L14.061,32H26v2H28z M46,30h-3h-2H28h-2H13h-2H8V17h38V30z",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 0.73,
      strokeWidth: "5.8055px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.991,28h24.018C40.658,28,42,26.654,42,25s-1.342-3-2.991-3H14.991C13.342,22,12,23.346,12,25S13.342,28,14.991,28z M14.991,24h24.018C39.564,24,40,24.44,40,25c0,0.551-0.445,1-0.991,1H14.991C14.436,26,14,25.56,14,25 C14,24.449,14.445,24,14.991,24z",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 0.73,
      strokeWidth: "5.8055px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 37,
    width: 12,
    height: 2,
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 0.73,
      strokeWidth: "5.8055px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 40,
    width: 5,
    height: 2,
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 0.73,
      strokeWidth: "5.8055px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.867968, 0, 0, 0.854537, 2271.942695, 115.366237)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.867968, 0, 0, 0.854537, 2271.942695, 115.366237)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.867968, 0, 0, 0.854537, 2271.942695, 115.366237)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.867968, 0, 0, 0.854537, 2271.942695, 115.366237)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.867968, 0, 0, 0.854537, 2271.942695, 115.366237)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.867968, 0, 0, 0.854537, 2271.942695, 115.366237)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.867968, 0, 0, 0.854537, 2271.942695, 115.366237)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.867968, 0, 0, 0.854537, 2271.942695, 115.366237)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.867968, 0, 0, 0.854537, 2271.942695, 115.366237)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.867968, 0, 0, 0.854537, 2271.942695, 115.366237)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.867968, 0, 0, 0.854537, 2271.942695, 115.366237)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.867968, 0, 0, 0.854537, 2271.942695, 115.366237)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.867968, 0, 0, 0.854537, 2271.942695, 115.366237)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.867968, 0, 0, 0.854537, 2271.942695, 115.366237)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.867968, 0, 0, 0.854537, 2271.942695, 115.366237)",
    style: {}
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo3.d9f241bec0556846d125a5af56dca18d.svg";
export { ForwardRef as ReactComponent };